"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSwitchConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcSwitchConstants = (function () {
    function BcSwitchConstants() {
    }
    BcSwitchConstants.BC_SWITCH_CONTAINER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-switch-container");
    return BcSwitchConstants;
}());
exports.BcSwitchConstants = BcSwitchConstants;
